<!-- 首页轮播 -->

<script setup></script>

<template>
  <div id="carousel">
    <button-router></button-router>

    <router-view v-slot="{ Component }">
      <!-- <keep-alive> -->
      <component :is="Component"></component>
      <!-- </keep-alive> -->
    </router-view>
  </div>
</template>

<style lang="scss" scoped>
#carousel {
  height: 100%;
}
</style>
